<template>
  <div class="news">
    <TopNavBar :navtitle="ChannelsName"></TopNavBar>
    <div class="newslist" v-if="ChannelsList && ChannelsList.length > 0">
      <ul>
        <li v-for="(NewsItem, index) in ChannelsList" :key="index">
            <van-cell :title="NewsItem.CName" is-link  @click="goToUrl(NewsItem)" />
        </li>
      </ul>
    </div>
    <van-empty v-else description="暂无数据..." />
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar.vue";
import { GetChannelsList } from "@/api/public";
export default {
  components: {
    TopNavBar,
  },
  data() {
    return {
      ChannelsList: [],
      ChannelsName: "",
    };
  },
    watch: {
    $route (to, from) {
      window.location.reload();
    }
  },
  mounted() {
    if (this.$route.query.CID != undefined) {
      GetChannelsList()
        .then((result) => {
          if (result.listData.length>0) {
              this.ChannelsList=[];
            result.listData.forEach((channel) => {
              if (channel.ParentID == this.$route.query.CID) {
                channel.chind = result.listData.filter(
                  (item) => item.ParentID == channel.CID
                );
                this.ChannelsList.push(channel);
              }
            });
            this.showload = false;
          }
        })
        .catch((err) => {
          this.$router.push("/404");
        });
    } else {
      this.$router.push("/404");
    }
  },
  
  methods: {
    goToUrl(item) {
      if (item.chind && item.chind.length>0) {
         this.$router.push(`/Channels?CID=${item.CID}`);
      } else {
        this.$router.push(`/NewsList?CID=${item.CID}` );
      }
    },
  },
};
</script>

<style>
</style>